import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import LandingNav from '../components/LandingNav';
import Footer from '../components/Footer';

const nextSteps = [
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Check your email',
    description: 'A confirmation email with your application details has been sent to your inbox.',
  },
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
      </svg>
    ),
    title: 'Expect a call',
    description: 'A licensed member of the Doorly team will call you within 1 business day to discuss your options.',
  },
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
    title: 'Prepare your documents',
    description: 'Start gathering: W-2s or tax returns (2 years), recent pay stubs, bank statements, and government-issued ID.',
  },
];

function ThankYou() {
  const location = useLocation();
  const name = location.state?.name || 'there';

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* 🔑 The landing page's header and menu (Jesse, 2026-10-19): in the flow, padded for the safe area. */}
      <LandingNav />

      <main className="flex-1 pt-10 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto">
          {/* Checkmark Card */}
          <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12 text-center mb-6">
            {/* Gold checkmark */}
            <div className="inline-flex items-center justify-center w-20 h-20 bg-blue-50 rounded-full mb-6 mx-auto">
              <svg
                className="w-10 h-10 text-doorly-blue"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>

            <h1 className="text-3xl sm:text-4xl font-bold text-black mb-3">
              Thank You, {name}!
            </h1>
            <p className="text-gray-600 text-lg leading-relaxed">
              Your mortgage application has been received. Our team is reviewing your information
              and will be in touch shortly.
            </p>
          </div>

          {/* What Happens Next */}
          <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 mb-6">
            <h2 className="text-xl font-bold text-black mb-6 flex items-center gap-2">
              <svg className="w-5 h-5 text-doorly-blue" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
              </svg>
              What Happens Next
            </h2>
            <ol className="space-y-5">
              {nextSteps.map((step, index) => (
                <li key={index} className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-doorly-blue rounded-xl flex items-center justify-center text-white">
                    {step.icon}
                  </div>
                  <div>
                    <p className="font-semibold text-black">{step.title}</p>
                    <p className="text-gray-600 text-sm mt-0.5 leading-relaxed">{step.description}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Link to="/dashboard" className="doorly-cta flex-1 justify-center py-3.5">
              <span className="doorly-cta-text">Go to My Dashboard</span>
              <span className="doorly-cta-badge" aria-hidden="true">→</span>
            </Link>
            <Link to="/" className="doorly-cta doorly-cta-outline flex-1 justify-center py-3.5">
              <span className="doorly-cta-text">Back to Home</span>
              <span className="doorly-cta-badge" aria-hidden="true">→</span>
            </Link>
          </div>

        </div>
      </main>

      <Footer />
    </div>
  );
}

export default ThankYou;
